import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import i18n from 'kodyl-js/i18n/react';

@i18n
class SimpleModal extends Component {
  render() {
    const { children, onClose, title, show, footer, ...props } = this.props;

    const content =
      typeof children === 'function' ? (
        children()
      ) : (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{children}</Modal.Body>
          <Modal.Footer>
            {footer || <Button onClick={onClose}>{this.i18n('Close')}</Button>}
          </Modal.Footer>
        </>
      );

    return (
      <Modal show={show} onHide={onClose} bsSize="large" {...props}>
        {content}
      </Modal>
    );
  }
}

export default SimpleModal;
